module.exports = __webpack_public_path__ + "static/media/axiom_kanombe2.2fffd193.jpg";